<script>
import Timeline from '@components/timeline.vue'
export default {
  components: {
    Timeline,
  },
}
</script>



<template>
  <Timeline />
</template>
